import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';

export const Container = styled(Box)(() => ({
  width: '100%'
}));

export const PlainRow = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: 16,
  marginBottom: 16
}));

export const SliderProvider = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  marginBottom: theme.spacing(2)
}));

export const Viewport = styled(Box, { shouldForwardProp: prop => prop !== 'width' })<{ width?: number }>(
  ({ width }) => ({
    overflow: 'hidden',
    width
  })
);

export const Track = styled(Box, { shouldForwardProp: prop => prop !== 'offset' })<{ offset: number }>(
  ({ offset }) => ({
    display: 'flex',
    flexWrap: 'nowrap',
    gap: 16,
    transition: 'transform 0.3s ease',
    transform: `translateX(-${offset}px)`
  })
);

export const ChipWrapper = styled(Box)(() => ({
  flexShrink: 0
}));

export const ArrowButtonPrev = styled(IconButton)(({ theme }) => ({
  width: 32,
  height: 32,
  backgroundColor: theme.palette.neutrals.beige3,
  flexShrink: 0,
  '&.Mui-disabled': {
    opacity: 0.4
  }
}));

export const ArrowButtonNext = styled(IconButton)(({ theme }) => ({
  width: 32,
  height: 32,
  backgroundColor: theme.palette.neutrals.beige3,
  flexShrink: 0,
  '&.Mui-disabled': {
    opacity: 0.4
  }
}));
